import { atom, useRecoilValue } from 'recoil'

export type CommentaryStoreType = {
    selectedCommitteeID: number | null
}
export const commentaryStore = atom<CommentaryStoreType>({
    key: 'commentaryStore',
    default: {
        selectedCommitteeID: null
    },
})

const useCommentaryStore = () => {
    const commentaryState = useRecoilValue(commentaryStore)
    return {
        ...commentaryState,
    }
}

export default useCommentaryStore
